module.exports = __webpack_public_path__ + "static/media/006-pompom-purple.b3280e71.svg";